export default __webpack_public_path__ + "static/media/info-filled.6e5ddd40.svg";